import Api from '@/services/Index';

const getAll = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/instructor/sections', formData);
}

export default {getAll}
